///
/// EarthBrowser
///
/// Created by Matt Giger on 9/16/2026
/// Copyright (c) 2026 Geodata Labs
///
/// Non-persisted mirror of the resolved subscription entitlement so that
/// non-React engine code (dataset layers) can read the paid depth tier from
/// appStore the same way it reads visibleDatasets. Kept in sync by
/// useEntitlementsSync (mounted in PageContent). Deliberately not persisted:
/// the source of truth is the getUserSubscription query, and free-tier
/// defaults on load prevent a stale "paid" flag from leaking depth.

import { createSlice, type PayloadAction } from '@reduxjs/toolkit'

export interface EntitlementsState {
	isPaid: boolean
}

const initialState: EntitlementsState = {
	isPaid: false,
}

export const entitlementsSlice = createSlice({
	name: 'entitlements',
	initialState,
	reducers: {
		setPaidEntitlement(state, action: PayloadAction<boolean>) {
			state.isPaid = action.payload
		},
	},
})

export const { setPaidEntitlement } = entitlementsSlice.actions
